import { Register } from '@features/Contractor/Register'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'

export const Route = createFileRoute('/contractor/register')({
  component: Register,
  staticData: {
    breadcrumb: t('contractor.register.breadcrumb'),
  },
})
